import "../CSS/loader.css"
const Loader = () => {
    return (
        <div class="concentric-container">
            <div class="loader-container">
                <div class="loader">
                    <div class="inner-circle"></div>
                    <div class="middle-circle"></div>
                    <div class="outer-circle"></div>
                </div>
                <p>Loading...</p>
            </div>
        </div>



    )

}
export default Loader;